import { render, staticRenderFns } from "./AccountDiscounts.vue?vue&type=template&id=05c7e25a&"
import script from "./AccountDiscounts.vue?vue&type=script&lang=js&"
export * from "./AccountDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./AccountDiscounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports